import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import { tokens } from "../../theme";
import { useState, useEffect } from "react";
import InputBase from "@mui/material/InputBase";
import NotificationOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import axios from "axios";

const TopBar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [user, setUser] = useState(null); // ✅ local state
  const navigate = useNavigate();
  const [currentUser, setCurrentUser] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // ✅ Load user (localStorage first, fallback API)
  useEffect(() => {
    const token = localStorage.getItem("token");
  
    if (token) {
      axios.get("http://localhost:8000/api/user", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setCurrentUser(res.data); // 🔥 THIS is what you were missing
      })
      .catch(() => {
        console.log("Failed to fetch user");
      });
    }
  }, []);
  
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
    handleClose();
  };

  return (
    <Box 
      display="flex" 
      justifyContent="space-between"
      gap="10px" alignItems="center" 
      p="10px" borderBottom="1.5px solid #e5e7eb"
      position="fixed"
      top={0}
      right={0}
      zIndex={1000}
      backgroundColor="#fff"
      width="83%"
    >
      
      <Box
        ml="20px"
        backgroundColor={tokens.grey[100]}
        border="1.5px solid #e5e7eb"
        borderRadius="8px"
        width="100%"
        maxWidth="400px"
        alignItems="center"
        sx={{ height: "32px"}}
      >
        <IconButton type="button">
          <SearchIcon sx={{ fontSize: "16px", color: "#85888d" }} />
        </IconButton>
        <InputBase
          sx={{
            fontSize: "13px",
            p: "2px 0",
            "&::placeholder": {
              color: tokens.grey[100],
              opacity: 1
            }
          }}
          placeholder="Search"
        />
      </Box>

      <Box display="flex" alignItems="center" gap="10px">
        <IconButton>
          <NotificationOutlinedIcon sx={{ color: "#85888d" }}/>
        </IconButton>
      
        <Box display="flex" alignItems="center">
          <Box
            width="30px"
            height="30px"
            borderRadius="50%"
            backgroundColor={tokens.redAccent[100]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            mr="10px"
          >
            <Typography fontSize="15px" color={tokens.redAccent[400]}>
              {user?.name ? user.name.charAt(0).toUpperCase() : "A"}
            </Typography>
          </Box>

          <Box sx={{cursor: "pointer"}} onClick={handleClick}>
            <Typography fontSize="15px" fontWeight="500">
              {currentUser?.name || "PetStore"}
            </Typography>
            <Typography fontSize="12px" fontWeight="thinner">
              Admin
            </Typography>
          </Box>
        </Box>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleLogout}>
          <LogoutIcon sx={{ mr: "8px" }} />
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default TopBar;